  // update as per the data received
  const generateBookingPayload = (payloadToUpdate, dataToUpdate, updateLocation, storeData) => {
    if(updateLocation === 'firstLayer'){

      return{
        ...storeData,
        ...dataToUpdate
      }
    }

    if(updateLocation === "secondLayer"){
      return{
        ...storeData,
        [payloadToUpdate]: {
          ...storeData[payloadToUpdate],
          ...dataToUpdate
          }
        }
    }
    else if(updateLocation === "thirdLayer"){
      return{
        ...storeData,
        [payloadToUpdate]: {
          ...storeData[payloadToUpdate],
          [dataToUpdate?.payloadToUpdate]:{
            ...storeData[payloadToUpdate][dataToUpdate?.payloadToUpdate],
                [dataToUpdate?.key]:dataToUpdate?.value
          }
          }
        }
    }
    else if(updateLocation === "toAddDataToThirdLayerForArray"){
        // console.log("Check")
      return{
        ...storeData,
        [payloadToUpdate]: {
          ...storeData[payloadToUpdate],
          [dataToUpdate?.payloadToUpdate]: [
            ...storeData[payloadToUpdate][dataToUpdate?.payloadToUpdate],
            dataToUpdate?.value
          ],
        }
      }
    }
    else if(updateLocation === "toAlterDataToThirdLayerForArray"){
      console.log(payloadToUpdate,dataToUpdate, storeData,"check data")
      return{
        ...storeData,
        [payloadToUpdate]: {
            ...storeData[payloadToUpdate],
            [dataToUpdate?.payloadToUpdate]: storeData[payloadToUpdate][dataToUpdate?.payloadToUpdate].map(obj => {
              if (obj.unit === dataToUpdate?.valueToUpdateOf) {
                return {
                  ...obj,
                  ...dataToUpdate?.allValuesToUpdate
                };
              }
              return obj;
            }),
          }
      }
    }
    else if(updateLocation === "toReplaceDataToThirdLayerForArray"){
      return{
        ...storeData,
        [payloadToUpdate]: {
          ...storeData[payloadToUpdate],
          [dataToUpdate?.payloadToUpdate]:
            dataToUpdate?.value
          ,
        }
      }
    }
  }
  export default generateBookingPayload;
